import { CUSTOMER_MATCH_SIGNAL_RU } from '@wit-support/payment';
const _bridge = [true, true];
void _bridge;
/** Operator-facing RU label for one match signal. */
export function customerMatchSignalLabelRu(signal) {
    return CUSTOMER_MATCH_SIGNAL_RU[signal];
}
//# sourceMappingURL=customer-match-labels.js.map